module.exports = __webpack_public_path__ + "static/media/omega.b79aff1e.png";